module.exports = __webpack_public_path__ + "static/media/er.6b8e7d64.svg";